<template>
  <div class="scoreTableTodorhoilolt">
    <v-row>
      <v-col
        cols="4"
        lg="4"
        md="4"
        sm="4"
        class="ma-0 py-0"
        v-if="curriculum.lessons"
      >
        <table
          v-if="curriculum.lessons && curriculum.lessons.length > 0"
          class="scoreBorderedTable"
          style="width: 100%"
          :style="
            ui_setting.tableRowFont
              ? 'font-size: ' + ui_setting.tableRowFont + 'pt'
              : 'font-size:11pt'
          "
        >
          <thead>
            <tr>
              <th
                class="scoreTableTodorhoilolt-hcell"
                style="
                  border: 1px solid black;
                  text-align: center;
                  font-weight: bold !important;
                  padding: 2px;
                "
              >
                No.
              </th>
              <th
                class="scoreTableTodorhoilolt-hcell"
                v-if="languageType.languageType == 1"
                style="
                  border: 1px solid black;
                  text-align: center;
                  font-weight: bold !important;
                  padding: 2px;
                "
              >
                {{ _translatedString("Нэр") }}
              </th>
              <th
                class="scoreTableTodorhoilolt-hcell"
                v-if="languageType.languageType == 2"
                style="
                  border: 1px solid black;
                  text-align: center;
                  font-weight: bold !important;
                  padding: 2px;
                "
              >
                {{ _translatedString("Нэр") }}
              </th>
              <th
                class="scoreTableTodorhoilolt-hcell"
                v-if="languageType.languageType == 3"
                style="
                  border: 1px solid black;
                  text-align: center;
                  font-weight: bold !important;
                  padding: 2px;
                "
              >
                {{ _translatedString("Нэр") }}
              </th>
              <th
                class="scoreTableTodorhoilolt-hcell"
                v-if="showLessonCode"
                style="
                  border: 1px solid black;
                  text-align: center;
                  font-weight: bold !important;
                  padding: 2px;
                "
              >
                {{ _translatedString("Код") }}
              </th>
              <th
                class="scoreTableTodorhoilolt-hcell"
                style="
                  border: 1px solid black;
                  text-align: center;
                  font-weight: bold !important;
                  padding: 2px;
                "
              >
                {{ _translatedString("Кр") }}
              </th>
              <th
                class="scoreTableTodorhoilolt-hcell"
                style="
                  border: 1px solid black;
                  text-align: center;
                  font-weight: bold !important;
                  padding: 2px;
                "
              >
                {{ _translatedString("Оноо") }}
              </th>
              <th
                class="scoreTableTodorhoilolt-hcell"
                style="
                  border: 1px solid black;
                  text-align: center;
                  font-weight: bold !important;
                  padding: 2px;
                "
              >
                {{ _translatedString("Дүн") }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(clesson, clIndex) in reOrderedCurriculumLesssons"
              :key="'clesson' + clIndex"
              @click="_removeLesson(clesson)"
            >
              <template v-if="!clesson.isLessonType && clIndex <= table1size">
                <td
                  class="scoreTableTodorhoilolt-cell"
                  style="
                    text-align: center !important;
                    border: 1px solid black;
                    border-spacing: 0px !important;
                    padding: 0px;
                    width: 1%;
                  "
                >
                  {{ clesson.index }}
                </td>
                <td
                  class="scoreTableTodorhoilolt-cell text-left pl-2"
                  v-if="clesson.lessonStandard"
                  style="border: 1px solid black; text-align: center"
                >
                  {{ clesson.lessonStandard.name }}
                </td>
                <td
                  v-if="clesson.lessonStandard && languageType == 2"
                  class="scoreTableTodorhoilolt-cell text-left pl-2"
                  :style="
                    clesson.lessonStandard.nameEN ? '' : 'background-color:red'
                  "
                  style="border: 1px solid black; text-align: center"
                >
                  {{ clesson.lessonStandard.nameEN }}
                </td>
                <td
                  v-if="clesson.lessonStandard && languageType == 3"
                  class="scoreTableTodorhoilolt-cell text-left pl-2"
                  :style="
                    clesson.lessonStandard.nameMX ? '' : 'background-color:red'
                  "
                  style="border: 1px solid black; text-align: center"
                >
                  {{ clesson.lessonStandard.nameMX }}
                </td>
                <td
                  v-if="clesson.lessonStandard && showLessonCode"
                  class="scoreTableTodorhoilolt-cell text-left pl-2"
                  style="border: 1px solid black; text-align: center"
                >
                  {{ clesson.lessonStandard.code }}
                </td>
                <td
                  class="scoreTableTodorhoilolt-cell"
                  style="border: 1px solid black; text-align: center"
                  v-if="clesson.lessonStandard"
                >
                  {{ clesson.lessonStandard.credit }}
                </td>
                <td
                  class="scoreTableTodorhoilolt-cell"
                  style="border: 1px solid black; text-align: center"
                >
                  {{ _getStudentScore(clesson, false) }}
                </td>
                <td
                  class="scoreTableTodorhoilolt-cell"
                  style="border: 1px solid black; text-align: center"
                >
                  {{ _getStudentScore(clesson, true) }}
                </td>
              </template>
              <template v-else-if="table1size > clesson.index">
                <td
                  colspan="8"
                  style="
                    border: 1px solid black;
                    text-align: center;
                    font-weight: bold !important;
                  "
                >
                  {{ clesson.name }}
                </td></template
              >
            </tr>
          </tbody>
        </table>
      </v-col>
      <v-col
        cols="4"
        lg="4"
        md="4"
        sm="4"
        class="ma-0 py-0"
        v-if="curriculum.lessons"
      >
        <table
          v-if="curriculum.lessons && curriculum.lessons.length > 0"
          class="scoreBorderedTable"
          style="width: 100%"
          :style="
            ui_setting.tableRowFont
              ? 'font-size: ' + ui_setting.tableRowFont + 'pt'
              : 'font-size:11pt'
          "
        >
          <thead>
            <tr>
              <th
                class="scoreTableTodorhoilolt-hcell"
                style="
                  border: 1px solid black;
                  text-align: center;
                  font-weight: bold !important;
                  padding: 2px;
                "
              >
                No.
              </th>
              <th
                class="scoreTableTodorhoilolt-hcell"
                v-if="languageType.languageType == 1"
                style="
                  border: 1px solid black;
                  text-align: center;
                  font-weight: bold !important;
                  padding: 2px;
                "
              >
                {{ _translatedString("Нэр") }}
              </th>
              <th
                class="scoreTableTodorhoilolt-hcell"
                v-if="languageType.languageType == 2"
                style="
                  border: 1px solid black;
                  text-align: center;
                  font-weight: bold !important;
                  padding: 2px;
                "
              >
                {{ _translatedString("Нэр") }}
              </th>
              <th
                class="scoreTableTodorhoilolt-hcell"
                v-if="languageType.languageType == 3"
                style="
                  border: 1px solid black;
                  text-align: center;
                  font-weight: bold !important;
                  padding: 2px;
                "
              >
                {{ _translatedString("Нэр") }}
              </th>
              <th
                class="scoreTableTodorhoilolt-hcell"
                v-if="showLessonCode"
                style="
                  border: 1px solid black;
                  text-align: center;
                  font-weight: bold !important;
                  padding: 2px;
                "
              >
                {{ _translatedString("Код") }}
              </th>
              <th
                class="scoreTableTodorhoilolt-hcell"
                style="
                  border: 1px solid black;
                  text-align: center;
                  font-weight: bold !important;
                  padding: 2px;
                "
              >
                {{ _translatedString("Кр") }}
              </th>
              <th
                class="scoreTableTodorhoilolt-hcell"
                style="
                  border: 1px solid black;
                  text-align: center;
                  font-weight: bold !important;
                  padding: 2px;
                "
              >
                {{ _translatedString("Оноо") }}
              </th>
              <th
                class="scoreTableTodorhoilolt-hcell"
                style="
                  border: 1px solid black;
                  text-align: center;
                  font-weight: bold !important;
                  padding: 2px;
                "
              >
                {{ _translatedString("Дүн") }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(clesson, clIndex) in reOrderedCurriculumLesssons"
              :key="'clesson' + clIndex"
              @click="_removeLesson(clesson)"
            >
              <template
                v-if="
                  !clesson.isLessonType &&
                  clIndex > table1size &&
                  clIndex <= table2size
                "
              >
                <td
                  class="scoreTableTodorhoilolt-cell"
                  style="
                    text-align: center !important;
                    border: 1px solid black;
                    border-spacing: 0px !important;
                    padding: 0px;
                    width: 1%;
                  "
                >
                  {{ clesson.index }}
                </td>
                <td
                  class="scoreTableTodorhoilolt-cell text-left pl-2"
                  v-if="clesson.lessonStandard"
                  style="
                    border: 1px solid black;
                    text-align: center;

                    padding: 2px;
                  "
                >
                  {{ clesson.lessonStandard.name }}
                </td>
                <td
                  v-if="clesson.lessonStandard && languageType == 2"
                  class="scoreTableTodorhoilolt-cell text-left pl-2"
                  :style="
                    clesson.lessonStandard.nameEN ? '' : 'background-color:red'
                  "
                  style="
                    border: 1px solid black;
                    text-align: center;

                    padding: 2px;
                  "
                >
                  {{ clesson.lessonStandard.nameEN }}
                </td>
                <td
                  v-if="clesson.lessonStandard && languageType == 3"
                  class="scoreTableTodorhoilolt-cell text-left pl-2"
                  :style="
                    clesson.lessonStandard.nameMX ? '' : 'background-color:red'
                  "
                  style="
                    border: 1px solid black;
                    text-align: center;

                    padding: 2px;
                  "
                >
                  {{ clesson.lessonStandard.nameMX }}
                </td>
                <td
                  v-if="clesson.lessonStandard && showLessonCode"
                  class="scoreTableTodorhoilolt-cell text-left pl-2"
                  style="
                    border: 1px solid black;
                    text-align: center;

                    padding: 2px;
                    width: 10%;
                  "
                >
                  {{ clesson.lessonStandard.code }}
                </td>
                <td
                  class="scoreTableTodorhoilolt-cell"
                  style="
                    border: 1px solid black;
                    text-align: center;

                    padding: 2px;
                    width: 10%;
                  "
                  v-if="clesson.lessonStandard"
                >
                  {{ clesson.lessonStandard.credit }}
                </td>
                <td
                  class="scoreTableTodorhoilolt-cell"
                  style="
                    border: 1px solid black;
                    text-align: center;

                    padding: 2px;
                    width: 10%;
                  "
                >
                  {{ _getStudentScore(clesson, false) }}
                </td>
                <td
                  class="scoreTableTodorhoilolt-cell"
                  style="
                    border: 1px solid black;
                    text-align: center;

                    padding: 2px;
                    width: 10%;
                  "
                >
                  {{ _getStudentScore(clesson, true) }}
                </td>
              </template>
              <template
                v-else-if="
                  clesson.index >= table1size &&
                  clesson.index <= table2size &&
                  clesson.name
                "
              >
                <td
                  colspan="8"
                  style="
                    border: 1px solid black;
                    text-align: center;
                    font-weight: bold !important;
                    padding: 2px;
                  "
                >
                  {{ clesson.name }}
                </td></template
              >
            </tr>
          </tbody>
        </table>
      </v-col>
      <v-col
        cols="4"
        lg="4"
        md="4"
        sm="4"
        class="ma-0 py-0"
        v-if="curriculum.lessons"
      >
        <table
          v-if="curriculum.lessons && curriculum.lessons.length > 0"
          class="scoreBorderedTable"
          style="width: 100%"
          :style="
            ui_setting.tableRowFont
              ? 'font-size: ' + ui_setting.tableRowFont + 'pt'
              : 'font-size:11pt'
          "
        >
          <thead>
            <tr>
              <th
                class="scoreTableTodorhoilolt-hcell"
                style="
                  border: 1px solid black;
                  text-align: center;
                  font-weight: bold !important;
                  padding: 2px;
                "
              >
                No.
              </th>
              <th
                class="scoreTableTodorhoilolt-hcell"
                v-if="languageType.languageType == 1"
                style="
                  border: 1px solid black;
                  text-align: center;
                  font-weight: bold !important;
                  padding: 2px;
                "
              >
                {{ _translatedString("Нэр") }}
              </th>
              <th
                class="scoreTableTodorhoilolt-hcell"
                v-if="languageType.languageType == 2"
                style="
                  border: 1px solid black;
                  text-align: center;
                  font-weight: bold !important;
                  padding: 2px;
                "
              >
                {{ _translatedString("Нэр") }}
              </th>
              <th
                class="scoreTableTodorhoilolt-hcell"
                v-if="languageType.languageType == 3"
                style="
                  border: 1px solid black;
                  text-align: center;
                  font-weight: bold !important;
                  padding: 2px;
                "
              >
                {{ _translatedString("Нэр") }}
              </th>
              <th
                class="scoreTableTodorhoilolt-hcell"
                v-if="showLessonCode"
                style="
                  border: 1px solid black;
                  text-align: center;
                  font-weight: bold !important;
                  padding: 2px;
                "
              >
                {{ _translatedString("Код") }}
              </th>
              <th
                class="scoreTableTodorhoilolt-hcell"
                style="
                  border: 1px solid black;
                  text-align: center;
                  font-weight: bold !important;
                  padding: 2px;
                "
              >
                {{ _translatedString("Кр") }}
              </th>
              <th
                class="scoreTableTodorhoilolt-hcell"
                style="
                  border: 1px solid black;
                  text-align: center;
                  font-weight: bold !important;
                  padding: 2px;
                "
              >
                {{ _translatedString("Оноо") }}
              </th>
              <th
                class="scoreTableTodorhoilolt-hcell"
                style="
                  border: 1px solid black;
                  text-align: center;
                  font-weight: bold !important;
                  padding: 2px;
                "
              >
                {{ _translatedString("Дүн") }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(clesson, clIndex) in reOrderedCurriculumLesssons"
              :key="'clesson' + clIndex"
              @click="_removeLesson(clesson)"
            >
              <template
                v-if="
                  !clesson.isLessonType &&
                  clIndex > table2size &&
                  clIndex <= reOrderedCurriculumLesssons.length
                "
              >
                <td
                  class="scoreTableTodorhoilolt-cell"
                  style="
                    text-align: center !important;
                    border: 1px solid black;
                    border-spacing: 0px !important;
                    padding: 0px;
                    width: 1%;
                  "
                >
                  {{ clesson.index }}
                </td>
                <td
                  class="scoreTableTodorhoilolt-cell text-left pl-2"
                  v-if="clesson.lessonStandard"
                  style="
                    border: 1px solid black;
                    text-align: center;

                    padding: 2px;
                  "
                >
                  {{ clesson.lessonStandard.name }}
                </td>
                <td
                  v-if="clesson.lessonStandard && languageType == 2"
                  class="scoreTableTodorhoilolt-cell text-left pl-2"
                  :style="
                    clesson.lessonStandard.nameEN ? '' : 'background-color:red'
                  "
                  style="
                    border: 1px solid black;
                    text-align: center;

                    padding: 2px;
                  "
                >
                  {{ clesson.lessonStandard.nameEN }}
                </td>
                <td
                  v-if="clesson.lessonStandard && languageType == 3"
                  class="scoreTableTodorhoilolt-cell text-left pl-2"
                  :style="
                    clesson.lessonStandard.nameMX ? '' : 'background-color:red'
                  "
                  style="
                    border: 1px solid black;
                    text-align: center;

                    padding: 2px;
                  "
                >
                  {{ clesson.lessonStandard.nameMX }}
                </td>
                <td
                  v-if="clesson.lessonStandard && showLessonCode"
                  class="scoreTableTodorhoilolt-cell text-left pl-2"
                  style="
                    border: 1px solid black;
                    text-align: center;

                    padding: 2px;
                    width: 10%;
                  "
                >
                  {{ clesson.lessonStandard.code }}
                </td>
                <td
                  class="scoreTableTodorhoilolt-cell"
                  style="
                    border: 1px solid black;
                    text-align: center;

                    padding: 2px;
                    width: 10%;
                  "
                  v-if="clesson.lessonStandard"
                >
                  {{ clesson.lessonStandard.credit }}
                </td>
                <td
                  class="scoreTableTodorhoilolt-cell"
                  style="
                    border: 1px solid black;
                    text-align: center;

                    padding: 2px;
                    width: 10%;
                  "
                >
                  {{ _getStudentScore(clesson, false) }}
                </td>
                <td
                  class="scoreTableTodorhoilolt-cell"
                  style="
                    border: 1px solid black;
                    text-align: center;

                    padding: 2px;
                    width: 10%;
                  "
                >
                  {{ _getStudentScore(clesson, true) }}
                </td>
              </template>
              <template v-else-if="clesson.index > table2size">
                <td
                  colspan="8"
                  style="
                    border: 1px solid black;
                    text-align: center;
                    font-weight: bold !important;
                    padding: 2px;
                  "
                >
                  {{ clesson.name }}
                </td></template
              >
            </tr>
          </tbody>
        </table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      table1size: 19,
      table2size: 35,
      curriculumLessonTypes: [
        { name: "Ерөнхий суурь хичээл", code: 1, isLessonType: true },
        { name: "Мэргэжлийн суурь хичээл", code: 2, isLessonType: true },
        { name: "Мэргэшүүлэx хичээл", code: 3, isLessonType: true },
        { name: "Дадлага", code: 4, isLessonType: true },
        { name: "Дипломын ажил, төсөл, шалгалт", code: 5, isLessonType: true },
      ],
    };
  },
  props: {
    studentScores: {
      type: Array,
      required: true,
    },
    curriculum: {
      type: Object,
      required: true,
    },
    languageType: {
      type: Object,
      required: true,
    },
    showLessonCode: {
      type: Boolean,
      required: true,
    },
    ui_setting: {
      type: Object,
      required: true,
    },
  },
  created() {
    console.log(this.curriculum);
  },
  computed: {
    reOrderedCurriculumLesssons() {
      var list = [];
      var counter = 0;
      if (this.curriculum.lessons) {
        for (const cc of this.curriculumLessonTypes) {
          cc.index = counter;
          list.push(cc);
          for (const curriculumLesson of this.curriculum.lessons) {
            if (curriculumLesson.curriculumLessonType.code == cc.code) {
              counter++;
              curriculumLesson.index = counter;
              list.push(curriculumLesson);
            }
          }
        }
      }
      return list;
    },
  },
  methods: {
    _translatedString(str) {
      return str;
    },
    _getStudentScore(curriculumLesson, asString) {
      var foundLesson = null;
      for (const lesson of this.studentScores) {
        if (
          curriculumLesson.lessonStandard &&
          curriculumLesson.lessonStandard.code == lesson.lessonCode
        ) {
          foundLesson = lesson;
          break;
        }
      }
      if (foundLesson) {
        if (asString) return this._getGPAString(foundLesson.scoreTotal);
        else return foundLesson.scoreTotal;
      } else return 0;
    },

    _getGPAString(score) {
      if (95 <= score && score <= 100) return "A+";
      else if (90 <= score && score <= 94) return "A";
      else if (87 <= score && score <= 89) return "B+";
      else if (80 <= score && score <= 86) return "B";
      else if (77 <= score && score <= 79) return "C+";
      else if (70 <= score && score <= 76) return "C";
      else if (60 <= score && score <= 69) return "D";
      else return "F,W,WF";
    },
  },
};
</script>
<style>
.btable {
  border-collapse: collapse;
  border: 1px solid black;
}
.btable th,
td {
  border: 1px solid black;
  padding: 8px;
}

.scoreBorderedTable {
  border-collapse: collapse;
}
.scoreTableTodorhoilolt-hcell {
  border: 1px solid black;
  text-align: left;
  padding: 8px;
  font-weight: bold !important;
}
.scoreTableTodorhoilolt-cell {
  border: 1px solid black;
  text-align: center;
  border-spacing: 0px !important;
  padding: 0px;
  cursor: pointer;
}
</style>